import { useEffect, useState } from "react";
import Url from '../LocalService';
import { useFetchServices } from "../hooks/useFetchServices";

export const Actions = () => {
  let [users, setUsers] = useState([]);
  let [userLength, setUserLength] = useState(null);
  let [filterdto, setFilterdto] = useState(undefined);
  let fetchservices = useFetchServices();

  useEffect(() => {
    /*
    fetch(Url + "usuario.getall.php")
      .then((res) => {
        return res.json();
      })
      */
      fetchservices.executeService({method:"GET",endpoint:"usuario.getall.php",body:{request:"getall"}})
      .then((data) => {
        if (data.success) {
          setUsers(data.data.reverse());
          setUserLength(true);
        } else {
          setUserLength(0);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // Inserting a new user into the database.
  const insertUser = (newUser) => {
    /*
    fetch(Url + "usuario.insert.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newUser),
    })
      .then((res) => {
        return res.json();
      })
      */
      fetchservices.executeService({method:"POST",endpoint:"usuario.insert.php",body:newUser})
      .then((data) => {
        if (data) {
          setUsers([
            {
              idusuario: data.idusuario,
              ...newUser,
            },
            ...users,
          ]);
          setUserLength(true);
        } else {
          alert(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Enabling the edit mode for a listed user.
  const editMode = (idusuario) => {
    users = users.map((user) => {
      if (user.idusuario === idusuario) {
        user.isEditing = true;
        return user;
      }
      user.isEditing = false;
      return user;
    });
    setUsers(users);
  };

  // Cance the edit mode.
  const cancelEdit = (idusuario) => {
    users = users.map((user) => {
      if (user.idusuario === idusuario) {
        user.isEditing = false;
        return user;
      }
      return user;
    });
    setUsers(users);
  };

  // Updating a user.
  const updateUser = (userData) => {
    /*
    fetch(Url + "usuario.update.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userData),
    })
      .then((res) => {
        return res.json();
      })
      */
      fetchservices.executeService({method:"POST",endpoint:"usuario.update.php",body:userData})
      .then((data) => {
        if (data.success) {
          users = users.map((user) => {
            if (user.idusuario === userData.idusuario) {
              user.isEditing = false;
              user.nome = userData.nome;
              user.login = userData.login;
              return user;
            }
            return user;
          });
          setUsers(users);
        } else {
          alert(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Deleting a user.
  const deleteUser = (theID) => {
      // filter outing the user.
    let userDeleted = users.filter((user) => {
      return user.idusuario !== theID;
    });
    /*
    fetch(Url + "usuario.delete.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ idusuario: theID }),
    })
      .then((res) => {
        return res.json();
      })
      */
      fetchservices.executeService({method:"POST",endpoint:"usuario.delete.php",body:{ idusuario: theID }})
      .then((data) => {
        if (data.success) {
          setUsers(userDeleted);
          if (users.length === 1) {
            setUserLength(0);
          }
        } else {
          alert(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return {
    users,
    editMode,
    cancelEdit,
    updateUser,
    insertUser,
    deleteUser,
    userLength,
    filterdto,
    setFilterdto,
  };
};